import * as mutations from "../../../../graphql/mutations";
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
import { useState } from "react";
import { useMutation } from "@apollo/client";
import { useHistory, useParams } from "react-router-dom";
import { useUserState } from "../../../../contexts/user.context";
import { useCreativeState } from "../../../../contexts/creative.context";
import { useMediaLoadingDispatch } from "../../../../contexts/mediaLoading.context";
import { useNotificationDispatch } from "../../../../contexts/notification.context";
import { handleCreativeSave } from "./handleCreativeSave";
import is_new_creative from "../../../../hooks/is_new_creative";

export function SaveButton() {
  const user = useUserState();
  const creative = useCreativeState();
  const { creativeId } = useParams<Record<string, string | undefined>>();
  const [fileUploadInProgress, _setFileUploadInProgress] = useState(false);
  const isNewCreative = is_new_creative();
  const mediaLoadingDispatch = useMediaLoadingDispatch();
  const [saveExistingCreative] = useMutation(mutations.SAVE_EXISTING_CREATIVE);
  const [saveNewCreative] = useMutation(mutations.SAVE_NEW_CREATIVE);
  const history = useHistory();
  const notificationDispatch = useNotificationDispatch();

  return <ComponentLibrary.PCActionButton isDisabled={!creative.advertiserName} text="Save" iconLeft="check" isLoading={fileUploadInProgress} iconColor="color-text-5" textColor="color-text-5" color="" clickHandler={handleCreativeSave({ mediaLoadingDispatch, user, creative, creativeId, isNewCreative, saveExistingCreative, saveNewCreative, history, notificationDispatch })} />;
}
